@if (user && !userFailedToLoad) {
  <div>
    <div class="details-title row align-items-center mt-3">
      <h1 class="no-underline col-md-auto ps-0">{{ usersService.getUserDisplayName(user) }}</h1>
      @if (canEditUser) {
        <a class="title-functions col-md-auto"
          [routerLink]="['/admin/users', user.userName, 'edit']"
          [state]="{user: user, fullUser: true}" [attr.aria-label]="'content.edit-something' | translate:{what:user.userName}">
          <fa-icon [icon]="faEdit"></fa-icon>
          {{ 'content.edit' | translate }}
        </a>
      }
    </div>
    <h2>{{ 'content.login2' | translate }}</h2>
    <div class="row details-section">
      <div class="col-md-6 border-end">
        <div class="row">
          <div class="col-md-5">{{ 'content.user-id' | translate }}:</div>
          <div class="col-md-7">{{ user.userName }}</div>
        </div>
        <div class="row">
          <div class="col-md-5">{{ 'content.user-status' | translate }}:</div>
          <div class="col-md-7">{{ user.status }}</div>
        </div>
      </div>
      <div class="col-md-5">
        @if (authService.isNotMe(user) | async) {
          <div class="d-flex flex-column ps-2" #modalContainer>
            <span id="disable-user-dialog-label" class="d-none">{{ 'aria.confirm-disable-user-dialog' | translate }}</span>
            @if (canDisableUser && usersService.isUserEnabled(user)) {
              <app-icon-button
                alignment="vertical"
                [text]="'content.disable' | translate"
                [tooltip]="'content.disable-something' | translate:{what:user.userName}"
                [icon]="faUserAltSlash"
              (buttonClick)="disable('disable-user-dialog-label', modalContainer)"></app-icon-button>
            }
            <span id="enable-user-dialog-label" class="d-none">{{ 'aria.confirm-enable-user-dialog' | translate }}</span>
            @if (canEnableUser && usersService.isUserDisabled(user)) {
              <app-icon-button
                alignment="vertical"
                [text]="'content.enable' | translate"
                [tooltip]="'content.enable-something' | translate:{what:user.userName}"
                [icon]="faUserCheck"
              (buttonClick)="enable('enable-user-dialog-label', modalContainer)"></app-icon-button>
            }
            <span id="terminate-user-dialog-label" class="d-none">{{ 'aria.confirm-terminate-user-dialog' | translate }}</span>
            @if (canTerminateUser) {
              <app-icon-button
                alignment="vertical"
                [text]="'content.terminate' | translate"
                [tooltip]="'content.terminate-something' | translate:{what:user.userName}"
                [icon]="faTrash"
              (buttonClick)="terminate('terminate-user-dialog-label', modalContainer)"></app-icon-button>
            }
            <span id="reset-user-dialog-label" class="d-none">{{ 'aria.confirm-reset-user-password-dialog' | translate }}</span>
            @if (canResetPassword) {
              <app-icon-button
                alignment="vertical"
                [text]="'content.reset-password' | translate"
                [tooltip]="'content.reset-password-for' | translate:{who:user.userName}"
                [icon]="faKey"
              (buttonClick)="reset('reset-user-dialog-label', modalContainer)"></app-icon-button>
            }
          </div>
        }
      </div>
    </div>
    <h2>{{ 'content.user' | translate }}</h2>
    <div class="row details-section">
      <div class="col-md-6 border-end">
        <div class="row">
          <div class="col-md-5">{{ 'content.full-name' | translate }}:</div>
          <div class="col-md-7">{{ user.firstName + ' ' + user.middleName + ' ' + user.lastName }}</div>
        </div>
        <div class="row">
          <div class="col-md-5">{{ 'content.person.email' | translate }}:</div>
          <div class="col-md-7 text-break">{{ user.email }}</div>
        </div>
        <div class="row">
          <div class="col-md-5">{{ 'content.phone.phone' | translate }}:</div>
          <div class="col-md-7">{{ user.phone }}</div>
        </div>
      </div>
      <div class="col-md-5 ms-2">
        <div class="row">
          <div class="col-md-5">{{ 'content.company' | translate }}:</div>
          <div class="col-md-7">
            <a [routerLink]="['/admin/companies', user.company, 'details']">
              {{ user.company }}
            </a>
          </div>
        </div>
        <div class="row">
          <div class="col-md-5">{{ 'content.assigned-branches' | translate }}:</div>
          <div class="col-md-7">
            @for (branch of branchDetails(); track branch) {
              <div>{{ branch }}</div>
            }
          </div>
        </div>
      </div>
    </div>
    <h2>{{ 'content.security' | translate }}</h2>
    <div class="row details-section">
      <div class="col-md-6 border-end">
        <div class="row">
          <h3 class="col-md-12">{{ 'content.access-times' | translate }}</h3>
        </div>
        <div class="row">
          <div class="col-md-5">{{ 'content.time-zone' | translate }}:</div>
          <div class="col-md-7">{{ timeZones.get(user.timeZone.toString()) || user.timeZone }}</div>
        </div>
        @for (day of shortDaysOfWeek; track day; let i = $index) {
          <div class="row">
            <div class="col-md-5">{{ 'content.keyed.days-of-week.' + day | translate }}:</div>
            <div class="col-md-7">{{ accessTime(i + 1) | async }}</div>
          </div>
        }
        <div class="row">
          <h3 class="col-md-12 mt-3">{{ 'content.ip-address-restriction' | translate }}</h3>
        </div>
        @for (ipRestriction of user.ipRestrictions; track ipRestriction) {
          <div class="row">
            <div class="col-md-5">{{ 'content.address.address' | translate }}</div>
            <div class="col-md-7">{{ ipRestriction.ipFrom }} - {{ ipRestriction.ipTo }}</div>
          </div>
        }
      </div>
      <div class="col-md-5 ms-2"></div>
    </div>
    <div class="details-section">
      <h2 class="mt-4">{{ 'content.mfa' | translate }}</h2>
      <div class="mfa-admin">
        <app-mfa-user-device-admin [allowAddingDevice]="false"
          [allowChangingPrimary]="canChangePrimaryMfa"
          [allowRemovingDevice]="canRemoveMfa"
        [userName]="user.userName"></app-mfa-user-device-admin>
      </div>
    </div>
  </div>
}
@if (userFailedToLoad) {
  <div>
    {{ 'content.item-not-found' | translate:{item: userParam} }}
  </div>
}
